<template>
  <div class="container">
    <div class="not-found-frame">
      <div class="not-found-code">404</div>
      <h2 class="not-found-title">Page Not Found</h2>
      <p class="not-found-description"></p>
      <router-link to="/" class="not-found-home-link">Back to Home</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundView'
}
</script>

<style scoped>
.not-found-frame {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 75vh;
  text-align: center;
}

.not-found-code {
  font-size: 4rem;
  font-weight: bold;
  color: var(--color-accent);
  line-height: 1;
  margin-bottom: 16px;
}

.not-found-title {
  font-size: 1.6rem;
  margin-bottom: 12px;
}

.not-found-description {
  font-size: 1rem;
  color: var(--color-on-surface-variant, #666);
  margin-bottom: 32px;
}

.not-found-home-link {
  display: inline-block;
  padding: 10px 24px;
  border-radius: 8px;
  background-color: var(--color-primary);
  color: var(--color-on-primary);
  text-decoration: none;
  font-weight: 500;
  transition: opacity 0.2s;
}

.not-found-home-link:hover {
  opacity: 0.85;
}
</style>
